
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resetpassword",
      function () {
        return require("private-next-pages/resetpassword.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resetpassword"])
      });
    }
  